import Service from "../../apiService";
import GetProfilDinas from "view/component/ProfilDinas";

export const searchVisitLaporan = async (params) => {
  try {
    const response = await Service.post("/report/kunjungan_pasien", params);
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchSensusLaporan = async (params) => {
  try {
    const response = await Service.post("/report/visit_sensus", params);
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchSepuluhBesar = async (params) => {
  try {
    const response = await Service.post("/report/sepuluh_besar", params);
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const searchLB1 = async (params) => {
  try {
    const response = await Service.post("/report/lb1_puskesmas", params);
    if (response) {
      return response;
    }
  } catch (error) {
    return [];
  }
};

export const getDistrics = async () => {
  let data = await GetProfilDinas();
  let village = data?.village_id.toString();
  let district = village.substring(0, 4);
  try {
    const responses = await Service.get("/demograph/cities/find/" + district);
    if (responses) {
      return responses.data.districts.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getCities = async () => {
  try {
    const responses = await Service.get("/demograph/cities");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getDistricsAll = async () => {
  try {
    const responses = await Service.get("/demograph/districts");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getReligions = async () => {
  try {
    const responses = await Service.get("/management/religions/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getJobs = async () => {
  try {
    const responses = await Service.get("/management/jobs/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getEducations = async () => {
  try {
    const responses = await Service.get("/management/educations/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getPersyaratan = async (refId) => {
  try {
    const responses = await Service.get(
      `/department/persyaratan/find/${refId}`
    );
    if (responses) {
      return responses.data;
    }
  } catch (error) {
    return [];
  }
};

export const getHotelQuestions = async () => {
  try {
    const responses = await Service.get("/hotel/question/read");
    if (responses) {
      return responses.data;
    }
  } catch (error) {
    return [];
  }
};

export const getPaymentTypes = async () => {
  try {
    const responses = await Service.get("/management/payment_types/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getWorkAreas = async () => {
  try {
    const responses = await Service.get("/management/work_areas/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.village.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const fetchSexs = async () => {
  try {
    const responses = await Service.get("/management/sex/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const getICD = async (inputValue) => {
  if (inputValue.length >= 3) {
    try {
      const responses = await Service.get(
        "management/icd10/read?keyword=" + inputValue
      );
      if (responses) {
        return responses.data.data.map((data) => {
          return {
            value: data.id,
            label: `${data.code} - ${data.name}`,
          };
        });
      }
    } catch (error) {
      return [];
    }
  }
};

export const packagingRef = async () => {
  try {
    const responses = await Service.get("/pirt/packaging/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const nettoRef = async () => {
  try {
    const responses = await Service.get("/pirt/netto/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};

export const jenisPanganRef = async () => {
  try {
    const responses = await Service.get("/pirt/jenis_pangan/read");
    if (responses) {
      return responses.data.map((response) => {
        return { value: response.id, label: response.name };
      });
    }
  } catch (error) {
    return [];
  }
};
